import { Button } from "@mui/material";
import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            info: null,
        };
    }

    componentDidCatch(error, info) {
        this.setState({
            hasError: true,
            error,
            info,
        });
    }

    handleRefresh() {
        window.location.reload();
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flexCol alignCntr justifyCntr pdngSM fullVirtualHeight">
                    <div className="categoryImgBlock">
                        <img src="/network-error.png" alt="nopage" />
                    </div>
                    <div className="flexCol alignCntr mrgnTSM">
                        <span className="subHeadingSM textCntr  mrgnBMD">Network Error, Something went wrong</span>
                        <Button
                            disableElevation
                            disableFocusRipple
                            disableRipple
                            disableTouchRipple
                            color="primary"
                            onClick={this.handleRefresh}
                            variant="contained"
                            className="whiteTxt"
                            size="large"
                        >
                            Retry
                        </Button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
